<template>
    <b-col
        class="pr-0 pt-3"
        :class="{'col-12 col-md-4 pr-sm-3': GET_GRID_VIEW === 3, 'col-12 col-md-6 pr-sm-3': GET_GRID_VIEW === 2, 'col-12': GET_GRID_VIEW === 1}"
    >
        <ChartItem
            :icon="activeItem.icon"
            :title="activeItem.title"
            :ps-object-name="activeItem.name"
            :measurement="activeItem.value"
            :metric="activeItem.metric"
            :alternative="activeItem.alternative"
            :has-multi-dates="activeItem.containsMultiChartItem"
            :auto-start="activeItem.autoStart"
            :auto-start-time-frame="activeItem.autoStartTimeFrame"
            :show-triple-data="activeItem.showTripleData"
            :show-plot-line="activeItem.showPlotLine"
            :measuring-profile="activeItem.measuringProfile"
            @resize="toggleFullWidth"
        ></ChartItem>
    </b-col>
</template>

<script>
    import ChartItem from "./ChartItem";
    import {mapGetters} from "vuex";
    import {
        GET_GRID_VIEW
    } from "../../store/actions/sensors";

    /**
     * Acts as a column and a wrapper. It can be stretched.
     */

    export default {
        name: "ChartColumnWrapper",
        components: {
            ChartItem
        },
        computed: {
            ...mapGetters([ GET_GRID_VIEW]),
        },
        props: {
            activeItem: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                wide: false
            }
        },
        methods: {
            toggleFullWidth() {
                this.wide = !this.wide
            }
        }
    }
</script>
